import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export interface AddIpBlockPayload {
	id: number ;
	name: string;
	ip: string;
	mask: number;
	providerId:number;
	countryId: string;
	operationType: string;
	ipTypeId?: number;
	datacenterId?: string | null;
	provider?: {
		name: string;
	};
	country?: {
		name: string;
	};
	ipVersion?: {
		name: string;
	};
	datacenter?: {
		name: string;
	} | null;
}

//GET v1/ip-block
export function getIpBlocks(token: string) {
	return axios.get(`${API_URL}/v1/resource-manager/ip-blocks`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}

//POST v1/ip-block
export function addIp(token: string, payload: AddIpBlockPayload) {
	return axios.post(`${API_URL}/v1/ip-block`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//PUT v1/ip-block/:id
export function editIp(token: string, id: number, payload: AddIpBlockPayload) {
	const encodedId = encodeURIComponent(id);
	return axios.put(`${API_URL}/v1/ip-block/${encodedId}`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//DELETE v1/ip-block
export function deleteIp(token: string, id: number) {
	const encodedId = encodeURIComponent(id);
	return axios.delete(`${API_URL}/v1/ip-block/${encodedId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
